import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as actions from "../../actions";
import { useLocation } from "react-router-dom";
import * as Template from "../../templates";
import { formatNumber } from "../../libraries/helper";
 
export default () => {

  const moduleName = "shippings";
  const location = useLocation()
  const appReducer = useSelector((state) => state.appReducer);
  const dispatch = useDispatch();
  const [rows, setRows] = useState([])
  const [totalPages, setTotalPages] = useState(0)

  const handleDelete = id => dispatch(actions.destroy(id, moduleName))

  useEffect(() => {
    dispatch(actions.list(moduleName, location.search));
  }, [appReducer.shippings_destroy, location.search]);

  useEffect(() => {
    if (appReducer.shippings_list != undefined) {
      setRows(appReducer.shippings_list.data)
      setTotalPages(appReducer.shippings_list.count)
    }
  }, [appReducer])


  const columns = [
    {
      name: 'نام',
      selector: row => row.name,
    },
    {
      name: 'مبلغ پایه فاکتور',
      selector: row => row.min == 10000000000000 ? "-" : formatNumber(row.min) + ` تومان `,
    },
    {
      name: 'قیمت',
      selector: row => row.price == 0 ? "رایگان" : formatNumber(row.price) + ` تومان `,
    },
    {
      name: 'تاریخ ایجاد',
      selector: row => row.created_at,
    },
    {
      name: 'عملیات',
      selector: row => <Template.TableButton handleDelete={() => handleDelete(row.id)} row={row} location={location} />,
    },
  ];

  return <Template.Table count={totalPages}  columns={columns} data={rows} />;

};
